// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mark-down {
    display: block;
    font-size: var(--font-size);
    max-width: var(--markdown-max-width);
    min-width: 320px;
    margin: auto;
    color: var(--foreground-color);
    visibility: hidden;
}

mark-down[rendered] {
    visibility: visible;
}

mark-down link-tag {
    color: var(--highlight-color);
    background-color: var(--secondary-highlight-color);
}

mark-down .task-list-ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

mark-down ul.contains-task-list {
    list-style: none;
    padding: 0;
    margin: 0;

}

mark-down ul.contains-task-list li,
mark-down li.cm-todo-item {
    padding: 0;
    list-style-type: none;
}

/* ── Todo markers (eight states) ─────────────────────────────────────── */

mark-down .cm-todo-marker {
    display: inline-block;
    width: 1.1em;
    text-align: center;
    font-style: normal;
    font-weight: normal;
    line-height: 1;
    vertical-align: baseline;
    font-size: 0.85em;
    position: relative;
    top: 0.04em;
    user-select: none;
    -webkit-user-select: none;
}

mark-down .cm-todo-open        { color: var(--neutral-fg-color); opacity: 0.6; }
mark-down .cm-todo-in-progress { color: var(--highlight-color); }
mark-down .cm-todo-important   { color: var(--warning-color, var(--error-color, var(--highlight-color))); }
mark-down .cm-todo-done        { color: var(--confirm-color, var(--neutral-fg-color)); opacity: 0.6; }
mark-down .cm-todo-cancelled   { color: var(--neutral-fg-color); opacity: 0.4; }
mark-down .cm-todo-question    { color: var(--secondary-color); }
mark-down .cm-todo-deferred    { color: var(--neutral-fg-color); opacity: 0.7; }
mark-down .cm-todo-starred     { color: var(--warning-color, var(--highlight-color)); }

/* Open/done markers are clickable (they dispatch the toggle event). */
mark-down .cm-todo-open,
mark-down .cm-todo-done {
    cursor: pointer;
}

/* ── Asides — Tufte-style sidenotes, matching the editor treatment ─────── */

mark-down .cm-aside-widget > aside {
    float: right;
    clear: right;
    width: 20ch;
    margin-right: -22ch; /* width + ~2ch gap so it clears the content column */
    margin-top: 0.3rem;
    margin-bottom: 0;
    margin-left: 1rem;
    font-size: 1rem;
    line-height: 1.3;
    color: var(--neutral-fg-color);
    font-style: italic;
}

mark-down .cm-aside-widget > aside p:last-child,
mark-down .cm-aside-widget > aside ul:last-child,
mark-down .cm-aside-widget > aside ol:last-child {
    margin-bottom: 0;
}

mark-down .cm-aside-widget > aside ul {
    padding-left: 1rem;
    list-style-type: none;
}

mark-down .cm-aside-widget > aside li::marker {
    color: var(--link-color, var(--highlight-color));
    content: "☞ ";
}

mark-down .cm-aside-widget > aside h1,
mark-down .cm-aside-widget > aside h2,
mark-down .cm-aside-widget > aside h3,
mark-down .cm-aside-widget > aside h4,
mark-down .cm-aside-widget > aside h5,
mark-down .cm-aside-widget > aside h6 {
    font-weight: 400;
    color: var(--neutral-fg-color);
    margin: 0 0 0.25rem;
    font-size: 1rem;
    line-height: 1.3;
}

/* Narrow viewports: no room for a margin band, so asides flow inline. */

@media (max-width: 720px) {
    mark-down .cm-aside-widget > aside {
        float: none;
        width: auto;
        margin: 1rem 0;
        padding-left: 1rem;
        border-left: 2px solid var(--highlight-color);
    }
}

/* ── Blockquote citations ─────────────────────────────────────────────── */

mark-down cite.cm-blockquote-cite {
    display: block;
    margin-top: 0.5em;
    text-align: right;
    font-style: italic;
    font-size: 0.9em;
    color: var(--neutral-fg-color);
}

mark-down cite.cm-blockquote-cite::before {
    content: "\\2014\\00a0"; /* — + non-breaking space */
    opacity: 0.5;
}

/* ── Inline extras: hashtags, mentions, hidden fields ─────────────────── */

mark-down .cm-hashtag-preview {
    color: var(--secondary-color);
    font-variant: small-caps;
    letter-spacing: 0.02em;
}

mark-down .cm-reference-preview {
    color: var(--link-color);
    font-variant: small-caps;
    letter-spacing: 0.02em;
}

mark-down .cm-hashtag-preview:hover,
mark-down .cm-reference-preview:hover {
    opacity: 0.75;
}

/* Metadata fields [key:: value] are invisible in rendered output. */
mark-down .cm-field-hidden {
    display: none;
}

/* ── Wikilinks ────────────────────────────────────────────────────────── */

mark-down .cm-wikilink-preview {
    color: var(--link-color);
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-offset: 0.15em;
}

/* ── Embedded figures ─────────────────────────────────────────────────── */

mark-down figure.cm-embedded-image {
    display: block;
    margin: 1.4rem auto;
    max-width: 90%;
}

mark-down figure.cm-embedded-image img,
mark-down figure.cm-embedded-image video {
    display: block;
    max-width: 100%;
    height: auto;
    margin: auto;
}

/* ── Charts ───────────────────────────────────────────────────────────── */

mark-down .cm-chart-widget {
    display: block;
    position: relative;
    /* Extend past the right edge of the text column so any margin note
       (aside / chart hover note) has its own band, exactly like the editor. */
    width: calc(100% + 22ch);
    margin: 1.4rem 0;
    text-align: center;
}

mark-down .cm-chart-widget dataroom-chart {
    display: block;
    position: relative;
    box-sizing: border-box;
    /* Reserve the 22ch margin band; chart content stays column-width. */
    padding-right: 22ch;
}

mark-down .cm-chart-widget dataroom-chart > svg {
    display: block;
    width: 100%;
    height: auto;
    max-width: none;
    margin: auto;
}

@media (max-width: 720px) {
    mark-down .cm-chart-widget {
        width: 100%;
    }

    mark-down .cm-chart-widget dataroom-chart {
        padding-right: 0;
    }
}

mark-down .chart-error.cm-chart-widget-error,
mark-down .network-error.cm-network-widget-error {
    padding: 1rem;
    text-align: left;
    color: var(--error-color, var(--foreground-color));
    background-color: var(--neutral-bg-color);
    border: 1px solid var(--error-color, var(--neutral-fg-color));
    border-radius: 4px;
    font-size: 0.9em;
}

mark-down .chart-error.cm-chart-widget-error pre,
mark-down .network-error.cm-network-widget-error pre {
    overflow-x: auto;
    margin-bottom: 0;
}

/* ── Networks ─────────────────────────────────────────────────────────── */

mark-down .cm-network-widget {
    display: block;
    margin: 1.4rem 0;
}

mark-down .cm-network-widget network-visualization {
    display: block;
    width: 100%;
    aspect-ratio: 4 / 3;
}

/* ── Sparklines ───────────────────────────────────────────────────────── */

mark-down spark-line {
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    color: var(--highlight-color);
}

mark-down spark-line svg {
    display: block;
    height: 1em;
    width: auto;
}


mark-down h1,
mark-down h2,
mark-down h3,
mark-down h4 {
    font-weight: 400;
    font-style: italic;
    margin-top: 1.2361em;
    margin-bottom: 1.2361rem;
}

mark-down h1 {
    font-size: var(--h1-font-size);
}

mark-down h2 {
    font-size: var(--h2-font-size);
}

mark-down h3 {
    font-size: var(--h3-font-size);
}

mark-down p,
mark-down dl,
mark-down ol,
mark-down ul {
    font-size: var(--font-size);
    line-height: var(--line-height);
}

mark-down a {
    color: var(--link-color);
}


mark-down p {
    margin-top: 1.4rem;
    margin-bottom: 1.4rem;
    vertical-align: baseline;
}

mark-down figure {
    max-width: 90%;
}

mark-down figure img {
    max-width: 100%;
    margin: auto;
}

mark-down figcaption {
    margin-right: 0%;
    margin-left: auto;
    max-width: none;
    max-width: 80%;
    font-size: 80%;
    font-style: italic;
    text-align: right;
}

mark-down blockquote {
    margin-left: 1.5em;
    margin-right: 0em;
    font-size: 130%;
    font-style: italic;
}

mark-down blockquote p,
mark-down blockquote footer {
    width: 100%;
}

mark-down hr {
  border: none;
  margin: 3em 0;
  height: 1pt;
  background-color: var(--neutral-bg-color);
}

/* Scrollbar styling for mark-down component */
/* Firefox */
mark-down,
mark-down * {
    scrollbar-color: var(--neutral-fg-color) var(--neutral-bg-color);
    scrollbar-width: thin;
}

/* Chromium, Safari, Edge */
mark-down *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

mark-down *::-webkit-scrollbar-track {
    background: var(--neutral-bg-color);
}

mark-down *::-webkit-scrollbar-thumb {
    background-color: var(--neutral-fg-color);
    border-radius: 8px;
    border: 2px solid var(--neutral-bg-color);
}

mark-down *::-webkit-scrollbar-thumb:hover {
    background-color: var(--secondary-color);
}

mark-down *::-webkit-scrollbar-thumb:active {
    background-color: var(--highlight-color);
}

mark-down *::-webkit-scrollbar-corner {
    background: var(--neutral-bg-color);
}

/* Checkbox styling for mark-down component */
/* Native accent-color (modern browsers) */
mark-down input[type="checkbox"] {
    accent-color: var(--highlight-color);
    width: 1rem;
    height: 1rem;
    vertical-align: text-bottom;
    border: 2px solid var(--neutral-fg-color);
    border-radius: 0.2rem;
    background-color: var(--background-color);
    cursor: pointer;
}

mark-down input[type="checkbox"]:hover:not(:disabled) {
    border-color: var(--secondary-color);
}

mark-down input[type="checkbox"]:checked {
    border-color: var(--highlight-color);
}

mark-down input[type="checkbox"]:focus-visible {
    outline: 2px solid var(--trinary-color);
    outline-offset: 2px;
}

mark-down input[type="checkbox"]:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}


/* Fallback for browsers without accent-color support */
@supports not (accent-color: red) {
    mark-down input[type="checkbox"] {
        -webkit-appearance: none;
        appearance: none;
        background-color: var(--background-color);
        display: inline-grid;
        place-content: center;
    }

    mark-down input[type="checkbox"]::before {
        content: "";
        width: 0.55rem;
        height: 0.55rem;
        transform: scale(0);
        transition: transform 120ms ease-in-out;
        box-shadow: inset 1rem 1rem var(--highlight-color);
        clip-path: polygon(14% 44%, 0 59%, 44% 100%, 100% 34%, 87% 20%, 44% 62%);
    }

    mark-down input[type="checkbox"]:checked::before {
        transform: scale(1);
    }
}`, "",{"version":3,"sources":["webpack://./styles/mark-down.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,2BAA2B;IAC3B,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;;AAEb;;AAEA;;IAEI,UAAU;IACV,qBAAqB;AACzB;;AAEA,2EAA2E;;AAE3E;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA,iCAAiC,8BAA8B,EAAE,YAAY,EAAE;AAC/E,iCAAiC,6BAA6B,EAAE;AAChE,iCAAiC,uEAAuE,EAAE;AAC1G,iCAAiC,oDAAoD,EAAE,YAAY,EAAE;AACrG,iCAAiC,8BAA8B,EAAE,YAAY,EAAE;AAC/E,iCAAiC,6BAA6B,EAAE;AAChE,iCAAiC,8BAA8B,EAAE,YAAY,EAAE;AAC/E,iCAAiC,mDAAmD,EAAE;;AAEtF,sEAAsE;AACtE;;IAEI,eAAe;AACnB;;AAEA,6EAA6E;;AAE7E;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB,EAAE,qDAAqD;IAC1E,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;IAChD,aAAa;AACjB;;AAEA;;;;;;IAMI,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,wEAAwE;;AAExE;IACI;QACI,WAAW;QACX,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,6CAA6C;IACjD;AACJ;;AAEA,4EAA4E;;AAE5E;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB,EAAE,2BAA2B;IAClD,YAAY;AAChB;;AAEA,4EAA4E;;AAE5E;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;AACjB;;AAEA,oEAAoE;AACpE;IACI,aAAa;AACjB;;AAEA,4EAA4E;;AAE5E;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA,4EAA4E;;AAE5E;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA,4EAA4E;;AAE5E;IACI,cAAc;IACd,kBAAkB;IAClB;8EAC0E;IAC1E,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,oEAAoE;IACpE,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,kDAAkD;IAClD,yCAAyC;IACzC,6DAA6D;IAC7D,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,4EAA4E;;AAE5E;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA,4EAA4E;;AAE5E;IACI,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;;AAGA;;;;IAII,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;;IAII,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,yCAAyC;AAC3C;;AAEA,8CAA8C;AAC9C,YAAY;AACZ;;IAEI,gEAAgE;IAChE,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;AACvC;;AAEA,6CAA6C;AAC7C,0CAA0C;AAC1C;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,yCAAyC;IACzC,qBAAqB;IACrB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;AAGA,uDAAuD;AACvD;IACI;QACI,wBAAwB;QACxB,gBAAgB;QAChB,yCAAyC;QACzC,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,eAAe;QACf,mBAAmB;QACnB,uCAAuC;QACvC,kDAAkD;QAClD,wEAAwE;IAC5E;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["mark-down {\n    display: block;\n    font-size: var(--font-size);\n    max-width: var(--markdown-max-width);\n    min-width: 320px;\n    margin: auto;\n    color: var(--foreground-color);\n    visibility: hidden;\n}\n\nmark-down[rendered] {\n    visibility: visible;\n}\n\nmark-down link-tag {\n    color: var(--highlight-color);\n    background-color: var(--secondary-highlight-color);\n}\n\nmark-down .task-list-ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\nmark-down ul.contains-task-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n}\n\nmark-down ul.contains-task-list li,\nmark-down li.cm-todo-item {\n    padding: 0;\n    list-style-type: none;\n}\n\n/* ── Todo markers (eight states) ─────────────────────────────────────── */\n\nmark-down .cm-todo-marker {\n    display: inline-block;\n    width: 1.1em;\n    text-align: center;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    vertical-align: baseline;\n    font-size: 0.85em;\n    position: relative;\n    top: 0.04em;\n    user-select: none;\n    -webkit-user-select: none;\n}\n\nmark-down .cm-todo-open        { color: var(--neutral-fg-color); opacity: 0.6; }\nmark-down .cm-todo-in-progress { color: var(--highlight-color); }\nmark-down .cm-todo-important   { color: var(--warning-color, var(--error-color, var(--highlight-color))); }\nmark-down .cm-todo-done        { color: var(--confirm-color, var(--neutral-fg-color)); opacity: 0.6; }\nmark-down .cm-todo-cancelled   { color: var(--neutral-fg-color); opacity: 0.4; }\nmark-down .cm-todo-question    { color: var(--secondary-color); }\nmark-down .cm-todo-deferred    { color: var(--neutral-fg-color); opacity: 0.7; }\nmark-down .cm-todo-starred     { color: var(--warning-color, var(--highlight-color)); }\n\n/* Open/done markers are clickable (they dispatch the toggle event). */\nmark-down .cm-todo-open,\nmark-down .cm-todo-done {\n    cursor: pointer;\n}\n\n/* ── Asides — Tufte-style sidenotes, matching the editor treatment ─────── */\n\nmark-down .cm-aside-widget > aside {\n    float: right;\n    clear: right;\n    width: 20ch;\n    margin-right: -22ch; /* width + ~2ch gap so it clears the content column */\n    margin-top: 0.3rem;\n    margin-bottom: 0;\n    margin-left: 1rem;\n    font-size: 1rem;\n    line-height: 1.3;\n    color: var(--neutral-fg-color);\n    font-style: italic;\n}\n\nmark-down .cm-aside-widget > aside p:last-child,\nmark-down .cm-aside-widget > aside ul:last-child,\nmark-down .cm-aside-widget > aside ol:last-child {\n    margin-bottom: 0;\n}\n\nmark-down .cm-aside-widget > aside ul {\n    padding-left: 1rem;\n    list-style-type: none;\n}\n\nmark-down .cm-aside-widget > aside li::marker {\n    color: var(--link-color, var(--highlight-color));\n    content: \"☞ \";\n}\n\nmark-down .cm-aside-widget > aside h1,\nmark-down .cm-aside-widget > aside h2,\nmark-down .cm-aside-widget > aside h3,\nmark-down .cm-aside-widget > aside h4,\nmark-down .cm-aside-widget > aside h5,\nmark-down .cm-aside-widget > aside h6 {\n    font-weight: 400;\n    color: var(--neutral-fg-color);\n    margin: 0 0 0.25rem;\n    font-size: 1rem;\n    line-height: 1.3;\n}\n\n/* Narrow viewports: no room for a margin band, so asides flow inline. */\n\n@media (max-width: 720px) {\n    mark-down .cm-aside-widget > aside {\n        float: none;\n        width: auto;\n        margin: 1rem 0;\n        padding-left: 1rem;\n        border-left: 2px solid var(--highlight-color);\n    }\n}\n\n/* ── Blockquote citations ─────────────────────────────────────────────── */\n\nmark-down cite.cm-blockquote-cite {\n    display: block;\n    margin-top: 0.5em;\n    text-align: right;\n    font-style: italic;\n    font-size: 0.9em;\n    color: var(--neutral-fg-color);\n}\n\nmark-down cite.cm-blockquote-cite::before {\n    content: \"\\2014\\00a0\"; /* — + non-breaking space */\n    opacity: 0.5;\n}\n\n/* ── Inline extras: hashtags, mentions, hidden fields ─────────────────── */\n\nmark-down .cm-hashtag-preview {\n    color: var(--secondary-color);\n    font-variant: small-caps;\n    letter-spacing: 0.02em;\n}\n\nmark-down .cm-reference-preview {\n    color: var(--link-color);\n    font-variant: small-caps;\n    letter-spacing: 0.02em;\n}\n\nmark-down .cm-hashtag-preview:hover,\nmark-down .cm-reference-preview:hover {\n    opacity: 0.75;\n}\n\n/* Metadata fields [key:: value] are invisible in rendered output. */\nmark-down .cm-field-hidden {\n    display: none;\n}\n\n/* ── Wikilinks ────────────────────────────────────────────────────────── */\n\nmark-down .cm-wikilink-preview {\n    color: var(--link-color);\n    text-decoration: underline;\n    text-decoration-style: dashed;\n    text-underline-offset: 0.15em;\n}\n\n/* ── Embedded figures ─────────────────────────────────────────────────── */\n\nmark-down figure.cm-embedded-image {\n    display: block;\n    margin: 1.4rem auto;\n    max-width: 90%;\n}\n\nmark-down figure.cm-embedded-image img,\nmark-down figure.cm-embedded-image video {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    margin: auto;\n}\n\n/* ── Charts ───────────────────────────────────────────────────────────── */\n\nmark-down .cm-chart-widget {\n    display: block;\n    position: relative;\n    /* Extend past the right edge of the text column so any margin note\n       (aside / chart hover note) has its own band, exactly like the editor. */\n    width: calc(100% + 22ch);\n    margin: 1.4rem 0;\n    text-align: center;\n}\n\nmark-down .cm-chart-widget dataroom-chart {\n    display: block;\n    position: relative;\n    box-sizing: border-box;\n    /* Reserve the 22ch margin band; chart content stays column-width. */\n    padding-right: 22ch;\n}\n\nmark-down .cm-chart-widget dataroom-chart > svg {\n    display: block;\n    width: 100%;\n    height: auto;\n    max-width: none;\n    margin: auto;\n}\n\n@media (max-width: 720px) {\n    mark-down .cm-chart-widget {\n        width: 100%;\n    }\n\n    mark-down .cm-chart-widget dataroom-chart {\n        padding-right: 0;\n    }\n}\n\nmark-down .chart-error.cm-chart-widget-error,\nmark-down .network-error.cm-network-widget-error {\n    padding: 1rem;\n    text-align: left;\n    color: var(--error-color, var(--foreground-color));\n    background-color: var(--neutral-bg-color);\n    border: 1px solid var(--error-color, var(--neutral-fg-color));\n    border-radius: 4px;\n    font-size: 0.9em;\n}\n\nmark-down .chart-error.cm-chart-widget-error pre,\nmark-down .network-error.cm-network-widget-error pre {\n    overflow-x: auto;\n    margin-bottom: 0;\n}\n\n/* ── Networks ─────────────────────────────────────────────────────────── */\n\nmark-down .cm-network-widget {\n    display: block;\n    margin: 1.4rem 0;\n}\n\nmark-down .cm-network-widget network-visualization {\n    display: block;\n    width: 100%;\n    aspect-ratio: 4 / 3;\n}\n\n/* ── Sparklines ───────────────────────────────────────────────────────── */\n\nmark-down spark-line {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    color: var(--highlight-color);\n}\n\nmark-down spark-line svg {\n    display: block;\n    height: 1em;\n    width: auto;\n}\n\n\nmark-down h1,\nmark-down h2,\nmark-down h3,\nmark-down h4 {\n    font-weight: 400;\n    font-style: italic;\n    margin-top: 1.2361em;\n    margin-bottom: 1.2361rem;\n}\n\nmark-down h1 {\n    font-size: var(--h1-font-size);\n}\n\nmark-down h2 {\n    font-size: var(--h2-font-size);\n}\n\nmark-down h3 {\n    font-size: var(--h3-font-size);\n}\n\nmark-down p,\nmark-down dl,\nmark-down ol,\nmark-down ul {\n    font-size: var(--font-size);\n    line-height: var(--line-height);\n}\n\nmark-down a {\n    color: var(--link-color);\n}\n\n\nmark-down p {\n    margin-top: 1.4rem;\n    margin-bottom: 1.4rem;\n    vertical-align: baseline;\n}\n\nmark-down figure {\n    max-width: 90%;\n}\n\nmark-down figure img {\n    max-width: 100%;\n    margin: auto;\n}\n\nmark-down figcaption {\n    margin-right: 0%;\n    margin-left: auto;\n    max-width: none;\n    max-width: 80%;\n    font-size: 80%;\n    font-style: italic;\n    text-align: right;\n}\n\nmark-down blockquote {\n    margin-left: 1.5em;\n    margin-right: 0em;\n    font-size: 130%;\n    font-style: italic;\n}\n\nmark-down blockquote p,\nmark-down blockquote footer {\n    width: 100%;\n}\n\nmark-down hr {\n  border: none;\n  margin: 3em 0;\n  height: 1pt;\n  background-color: var(--neutral-bg-color);\n}\n\n/* Scrollbar styling for mark-down component */\n/* Firefox */\nmark-down,\nmark-down * {\n    scrollbar-color: var(--neutral-fg-color) var(--neutral-bg-color);\n    scrollbar-width: thin;\n}\n\n/* Chromium, Safari, Edge */\nmark-down *::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n}\n\nmark-down *::-webkit-scrollbar-track {\n    background: var(--neutral-bg-color);\n}\n\nmark-down *::-webkit-scrollbar-thumb {\n    background-color: var(--neutral-fg-color);\n    border-radius: 8px;\n    border: 2px solid var(--neutral-bg-color);\n}\n\nmark-down *::-webkit-scrollbar-thumb:hover {\n    background-color: var(--secondary-color);\n}\n\nmark-down *::-webkit-scrollbar-thumb:active {\n    background-color: var(--highlight-color);\n}\n\nmark-down *::-webkit-scrollbar-corner {\n    background: var(--neutral-bg-color);\n}\n\n/* Checkbox styling for mark-down component */\n/* Native accent-color (modern browsers) */\nmark-down input[type=\"checkbox\"] {\n    accent-color: var(--highlight-color);\n    width: 1rem;\n    height: 1rem;\n    vertical-align: text-bottom;\n    border: 2px solid var(--neutral-fg-color);\n    border-radius: 0.2rem;\n    background-color: var(--background-color);\n    cursor: pointer;\n}\n\nmark-down input[type=\"checkbox\"]:hover:not(:disabled) {\n    border-color: var(--secondary-color);\n}\n\nmark-down input[type=\"checkbox\"]:checked {\n    border-color: var(--highlight-color);\n}\n\nmark-down input[type=\"checkbox\"]:focus-visible {\n    outline: 2px solid var(--trinary-color);\n    outline-offset: 2px;\n}\n\nmark-down input[type=\"checkbox\"]:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n\n/* Fallback for browsers without accent-color support */\n@supports not (accent-color: red) {\n    mark-down input[type=\"checkbox\"] {\n        -webkit-appearance: none;\n        appearance: none;\n        background-color: var(--background-color);\n        display: inline-grid;\n        place-content: center;\n    }\n\n    mark-down input[type=\"checkbox\"]::before {\n        content: \"\";\n        width: 0.55rem;\n        height: 0.55rem;\n        transform: scale(0);\n        transition: transform 120ms ease-in-out;\n        box-shadow: inset 1rem 1rem var(--highlight-color);\n        clip-path: polygon(14% 44%, 0 59%, 44% 100%, 100% 34%, 87% 20%, 44% 62%);\n    }\n\n    mark-down input[type=\"checkbox\"]:checked::before {\n        transform: scale(1);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
